import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { BalanceStore, BalanceState } from './balance.store';
import { Observable } from 'rxjs';
import { MemberQuery } from '../member/member.query';
import { Balance } from './balance.model';

@Injectable({ providedIn: 'root' })
export class BalanceQuery extends QueryEntity<BalanceState> {
  constructor(
    protected store: BalanceStore,
    protected memberQuery: MemberQuery
  ) {
    super(store);
  }

  selectPurse(purse: number, memberId?: string): Observable<number | undefined> {
    memberId = memberId || this.memberQuery.getUserContext().memberId;
    return this.selectEntity([memberId, purse].join('-'), 'balance');
  }

  getPurse(purse: number, memberId?: string): number {
    memberId = memberId || this.memberQuery.getUserContext().memberId;
    return this.getEntity([memberId, purse].join('-'))?.balance || 0;
  }

  selectBalancesByPurse(purse: number): Observable<Balance[]> {
    return this.selectAll({ filterBy: (balance) => balance.purseId === purse });
  }

  selectBalancesByMember(memberId: string): Observable<Balance[]> {
    return this.selectAll({ filterBy: (balance) => balance.memberId === memberId });
  }
}
